import type { ComponentType, SVGProps } from "react";

import StreamlineEssentialViewOffBold from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-essential-view-off-bold.svg?react";
import StreamlineEssentialView1Bold from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-essential-view-1-bold.svg?react";
import StreamlineEssentialCheckCircle1Bold from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-essential-check-circle-1-bold.svg?react";
import StreamlineArrowsArrowRight1Regular from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-arrows-arrow-right-1-regular.svg?react";
import StreamlineArrowsArrowLeft1Regular from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-arrows-arrow-left-1-regular.svg?react";
import StreamlineEssentialCloseRegular from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-essential-close-regular.svg?react";
import StreamlineEssentialSearchRegular from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-essential-search-regular.svg?react";
import StreamlineArrowsArrowDown1Regular from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-arrows-arrow-down-1-regular.svg?react";
import StreamlineArrowsArrowUp1Regular from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-arrows-arrow-up-1-regular.svg?react";
import StreamlineDevicesPhoneHandHold1Bold from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-devices-phone-hand-hold-1-bold.svg?react";
import StreamlineEmailsEnvelopeRegular from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-emails-envelope-regular.svg?react";
import StreamlineEssentialCheck1Bold from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-essential-check-1-bold.svg?react";
import StreamlineFinanceCreditCardRegular from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-finance-credit-card-regular.svg?react";
import StreamlineDevicesMobilePhoneRegular from "@sonaemc/mantra-tokens/web/icons/svgs/svg/streamline-devices-mobile-phone-regular.svg?react";

export const iconMap = Object.freeze({
  StreamlineEssentialViewOffBold,
  StreamlineEssentialView1Bold,
  StreamlineEssentialCheckCircle1Bold,
  StreamlineEssentialCheck1Bold,
  StreamlineArrowsArrowRight1Regular,
  StreamlineArrowsArrowLeft1Regular,
  StreamlineEssentialCloseRegular,
  StreamlineEssentialSearchRegular,
  StreamlineArrowsArrowDown1Regular,
  StreamlineArrowsArrowUp1Regular,
  StreamlineDevicesPhoneHandHold1Bold,
  StreamlineEmailsEnvelopeRegular,
  StreamlineFinanceCreditCardRegular,
  StreamlineDevicesMobilePhoneRegular,
}) as Record<string, ComponentType<SVGProps<SVGSVGElement>>>;

export type IconName = keyof typeof iconMap;
